var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLimitPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm8,39.13H19.18c-2.55,0-3.67-1.12-3.67-3.85V12.42c0-1.08.76-1.55,1.73-1.55S19,11.34,19,12.38V34.63a1.15,1.15,0,0,0,1.29,1.26H33a1.44,1.44,0,0,1,1.47,1.58A1.53,1.53,0,0,1,33,39.13Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLimitPolicy);
export default __webpack_public_path__ + "static/media/icon-limit-policy.be7e9fb8006cb01c48f0973aa6c7c578.svg";
export { ForwardRef as ReactComponent };